"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zip = exports.isNotUndefined = exports.hasErrors = exports.onlyRights = exports.memoize = exports.getItemsNotInSecondArray = exports.complement = exports.alwaysFalse = exports.alwaysTrue = exports.always = exports.getTargetYear = exports.getTargetMonth = exports.collectGeneratorAsync = exports.collectGenerator = exports.stripProp = exports.give = exports.identity = exports.set = exports.get = exports.ofLength = exports.call = exports.destroy = void 0;
const Either_1 = require("./Either");
const destroy = () => void 0;
exports.destroy = destroy;
const call = (...args) => (f) => f(...args);
exports.call = call;
const ofLength = (length) => (lengthy) => lengthy.length === length;
exports.ofLength = ofLength;
const get = (prop) => (obj) => obj[prop];
exports.get = get;
const set = (prop) => (value) => (obj) => ({
    ...obj,
    [prop]: value,
});
exports.set = set;
const identity = (v) => v;
exports.identity = identity;
const give = (v) => () => v;
exports.give = give;
const stripProp = (prop) => (obj) => {
    const result = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (key !== prop) {
                result[key] = obj[key];
            }
        }
    }
    return result;
};
exports.stripProp = stripProp;
const collectGenerator = (gen) => {
    if (gen instanceof Array) {
        return gen;
    }
    const ret = [];
    for (const i of gen) {
        ret.push(i);
    }
    return ret;
};
exports.collectGenerator = collectGenerator;
const collectGeneratorAsync = async (gen) => {
    const ret = [];
    for await (const i of gen) {
        ret.push(i);
    }
    return ret;
};
exports.collectGeneratorAsync = collectGeneratorAsync;
const getTargetMonth = (timestamp) => {
    const date = new Date(timestamp);
    return date.getMonth();
};
exports.getTargetMonth = getTargetMonth;
const getTargetYear = (timestamp) => {
    const date = new Date(timestamp);
    return date.getFullYear();
};
exports.getTargetYear = getTargetYear;
const always = (value) => () => value;
exports.always = always;
exports.alwaysTrue = exports.always(true);
exports.alwaysFalse = exports.always(false);
const complement = (func) => (...args) => !func(...args);
exports.complement = complement;
const getItemsNotInSecondArray = (equalityCheckFunction) => (list1) => (list2) => list1.filter(item => !list2.some(equalityCheckFunction(item)));
exports.getItemsNotInSecondArray = getItemsNotInSecondArray;
const memoize = (func, serialize) => {
    const returns = new Map();
    return (arg) => {
        if (serialize) {
            let value = returns.get(serialize(arg));
            if (!value) {
                value = func(arg);
                returns.set(serialize(arg), value);
            }
            return value;
        }
        else {
            let value = returns.get(arg);
            if (!value) {
                value = func(arg);
                returns.set(arg, value);
            }
            return value;
        }
    };
};
exports.memoize = memoize;
const onlyRights = (arr) => arr.filter(Either_1.Either.isRight).map(exports.get('value'));
exports.onlyRights = onlyRights;
const hasErrors = (arr) => arr.some(Either_1.Either.isLeft);
exports.hasErrors = hasErrors;
const isNotUndefined = (value) => !!value;
exports.isNotUndefined = isNotUndefined;
const zip = (arr1, arr2) => arr1.map((v1, i) => [v1, arr2[i]]);
exports.zip = zip;
//# sourceMappingURL=Util.js.map